import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { REAUTHENTICATE_ROUTE } from 'utils/constants';
import { selectCompany, selectProfileLoading } from 'store/common/selectors/profile';
import { useMeasuredHeaderPart } from 'layout/HeaderOffsets';

import styles from './Navbar.module.css';
// assets
import MedallionLogo from 'images/Medallion_Logo_TM_RGB.svg';
import ReAuthenticateLogo from 'assets/images/ReAuthenticate_rgb.svg';

const customHeight = new Set(['050ab87c-8f00-4761-ba4b-ae51df228454']);
const MEDALLION_LOGO_DEFAULT_HEIGHT = '30px';

function MainNavbar() {
    const company = useSelector(selectCompany);
    const loading = useSelector(selectProfileLoading);
    const location = useLocation();
    const measureRef = useMeasuredHeaderPart('navbar');

    const isReAuthenticateRoute = location?.pathname?.includes(REAUTHENTICATE_ROUTE);
    const isSessionExpired = location?.pathname?.includes('/session-expired');

    const isAuthenticating = company?.name === 'Authenticating.com';

    const fallbackLogo = isReAuthenticateRoute ? ReAuthenticateLogo : MedallionLogo;
    // Tolerates null / '' / whitespace / non-string values from the profile payload.
    const companyLogo = typeof company?.logo === 'string' ? company.logo.trim() : '';
    const logoSrc = !isAuthenticating && companyLogo ? companyLogo : fallbackLogo;

    const hasResolvedBrand = Boolean(company?.uuid || company?.name);
    const isLoading = (!loading && hasResolvedBrand) || isReAuthenticateRoute || isSessionExpired;

    const logoHeight = customHeight.has(company?.uuid) ? '50px' : MEDALLION_LOGO_DEFAULT_HEIGHT;

    return isLoading ? (
        <Box ref={measureRef} component="header" className={styles.navbar}>
            <img
                src={logoSrc}
                className={styles.img}
                alt="Logo"
                style={{ maxHeight: logoHeight }}
            />
        </Box>
    ) : null;
}

export default MainNavbar;
